import { CareProtocolOpportunitiesPageV2 } from "../../../ui/pages/v2";

export function CareProtocolOpportunitiesV2Route() {
  return <CareProtocolOpportunitiesPageV2 />;
}
